module.exports = __webpack_public_path__ + "img/98.8.29d42318.png";